"use client";

import React from "react";
import { Info, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: 1,
  title: "Wallet Setup",
  description: "Create and secure your personal digital wallet to hold your Aizalea tokens safely.",
  tooltip: "Download a secure Web3 wallet like MetaMask or Trust Wallet to store your digital assets."
}, {
  id: 2,
  title: "Asset Swap",
  description: "Acquire Aizalea by swapping your existing digital assets through our verified smart contracts.",
  tooltip: "Exchange standard cryptocurrencies (like ETH or USDT) for Aizalea tokens via our secure portal."
}, {
  id: 3,
  title: "Ecosystem Access",
  description: "Unlock the full potential of the AizaHcare ecosystem, from medical insights to advanced AI tools.",
  tooltip: "Use your tokens to access premium AI healthcare services and data insights."
}];
export default function AizaleaAcquisitionSteps() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}